module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n          Cortes "), _c('app-title-custom')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-2 sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por codigo"
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "intro-y mt-2 mb-4 flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/emails"
    }
  }, [_vm._v("Regresar")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "intro-y chat grid grid-cols-12 gap-5 mt-5"
  }, [_c('div', {
    staticClass: "col-span-12 lg:col-span-4 xxl:col-span-3"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "chats",
      "role": "tabpanel",
      "aria-labelledby": "chats-tab"
    }
  }, [_c('div', {
    staticClass: "chat__chat-list overflow-y-auto scrollbar-hidden pr-1 pt-1"
  }, _vm._l((_vm.filteredEmails), function(email, index) {
    return (email.state_id == 4 || email.state_id == 6) ? _c('div', {
      key: email.slug,
      staticClass: "intro-x cursor-pointer box relative flex items-center p-5",
      class: {
        'mt-5': index != 0
      },
      on: {
        "click": function($event) {
          return _vm.checkElement(email.id)
        }
      }
    }, [_c('div', {
      staticClass: "ml-2 overflow-hidden"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(email.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(email.campaign.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "w-full truncate text-gray-600 mt-0.5"
    }, [_vm._v(_vm._s(email.slug))]), _vm._v(" "), _c('div', {
      staticClass: "text-xs text-gray-500 ml-auto"
    }, [_vm._v(_vm._s(email.date))])]), _vm._v(" "), _c('div', {
      staticClass: "w-5 h-5 flex items-center justify-center absolute top-0 right-0 text-xs text-white rounded-full bg-theme-1 font-medium -mt-1 -mr-1"
    }, [_vm._v(_vm._s(email.pendingCheck))])]) : _vm._e()
  }), 0)])])]), _vm._v(" "), (_vm.emailCheck.state_id == 4 || _vm.emailCheck.state_id == 6) ? _c('div', {
    staticClass: "intro-y box col-span-12 lg:col-span-8 xxl:col-span-9"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-0 border-b border-gray-200 dark:border-dark-5"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Lista de aprobación: " + _vm._s(_vm.emailCheck.name) + "\n            ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "p-5"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "latest-tasks-new",
      "role": "tabpanel",
      "aria-labelledby": "latest-tasks-new-tab"
    }
  }, _vm._l((_vm.filteredCheckList), function(check, index) {
    return _c('div', {
      key: (index + "-checker"),
      staticClass: "flex items-center",
      class: {
        'mt-5': index != 0
      }
    }, [_c('div', {
      staticClass: "border-l-2 border-theme-1 pl-4"
    }, [_c('p', {
      staticClass: "font-medium"
    }, [_vm._v(_vm._s(check.type.description))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600"
    }, [_vm._v("Equipo: " + _vm._s(check.type.teamName))])]), _vm._v(" "), (!check.user_id && check.type.team_id == _vm.user.team_id) ? _c('div', {
      staticClass: "flex ml-auto"
    }, [_c('button', {
      staticClass: "bg-green-600 button--sm button mb-2 mr-1",
      on: {
        "click": function($event) {
          return _vm.changeCheckStatus(check, true)
        }
      }
    }, [_c('app-icon', {
      staticClass: "text-white",
      attrs: {
        "name": "check"
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "bg-red-600 button--sm button mb-2 mr-1",
      on: {
        "click": function($event) {
          return _vm.changeCheckStatus(check, false)
        }
      }
    }, [_c('app-icon', {
      staticClass: "text-white",
      attrs: {
        "name": "cancel"
      }
    })], 1)]) : _c('div', {
      staticClass: "flex ml-auto"
    }, [(check.user_id) ? _c('div', [(check.check) ? _c('button', {
      staticClass: "bg-green-900 button--sm button mb-2 mr-1",
      attrs: {
        "disabled": ""
      }
    }, [_c('app-icon', {
      staticClass: "text-white",
      attrs: {
        "name": "check"
      }
    })], 1) : _c('button', {
      staticClass: "bg-red-900 button--sm button mb-2 mr-1",
      attrs: {
        "disabled": ""
      }
    }, [_c('app-icon', {
      staticClass: "text-white",
      attrs: {
        "name": "cancel"
      }
    })], 1)]) : _vm._e()])])
  }), 0)])])]) : _vm._e()])]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav nav-tabs ml-auto hidden sm:flex",
    attrs: {
      "role": "tablist"
    }
  }, [_c('a', {
    staticClass: "py-5 ml-6 active",
    attrs: {
      "data-toggle": "tab",
      "data-target": "#latest-tasks-new",
      "href": "javascript:;",
      "id": "latest-tasks-mobile-new-tab",
      "role": "tab",
      "aria-selected": "true"
    }
  }, [_vm._v("Actual")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d244d304","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/email/EmailCheck.vue
// module id = 477
// module chunks = 1